module.exports = __webpack_public_path__ + "img/slogan.1c4e69d1.png";